import { render, staticRenderFns } from "./PointCharge.vue?vue&type=template&id=945577ac&scoped=true&"
import script from "./PointCharge.vue?vue&type=script&lang=js&"
export * from "./PointCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945577ac",
  null
  
)

export default component.exports